import React from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const CustomDatePicker = ({
  name,
  value,
  onChange,
  onBlur,
  placeholder = "Select Date",
  allowClear = true,
  showToday = true,
  size = "middle",
  error,
  touched,
  className = "",
  disableFuture = false,
  disablePast = false,
  minDate,
  maxDate,
  ...props
}) => {

   const disabledDate = (current) => {
    if (!current) return false;

    const now = dayjs();

    // Handle minDate and maxDate safely
    if (minDate && current.isBefore(dayjs(minDate), "day")) return true;
    if (maxDate && current.isAfter(dayjs(maxDate), "day")) return true;

    // Handle generic disable options
    if (disableFuture && current.isAfter(now, "day")) return true;
    if (disablePast && current.isBefore(now.startOf("day"))) return true;

    return false;
  };

  return (
    <DatePicker
        format="DD/MM/YYYY"
        value={value && value !== "" ? dayjs(value) : null}
        onChange={(date) => onChange(date ? date.format("YYYY-MM-DD") : null)}
        onPanelChange={(date) => onChange(date ? date.format("YYYY-MM-DD") : null)}
        onBlur={() => onBlur({ target: { name } })}
        name={name}
        style={{ width: "100%" }}
        placeholder={placeholder}
        allowClear={allowClear}
        disabledDate={disabledDate}
        showToday={showToday}
        size={size}
        {...props}
    />
  );
};

export default CustomDatePicker;
